module.exports = __webpack_public_path__ + "img/scene3copy01.43c1722d.png";